module.exports = __webpack_public_path__ + "static/media/gas-networks-ireland.8538cb49.png";